import { render, staticRenderFns } from "./PremiumOnlyTag.vue?vue&type=template&id=31b8965f"
import script from "./PremiumOnlyTag.vue?vue&type=script&lang=js"
export * from "./PremiumOnlyTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports